import { render, staticRenderFns } from "./AnswerSolutionDialog.vue?vue&type=template&id=b7d56196&"
import script from "./AnswerSolutionDialog.vue?vue&type=script&lang=js&"
export * from "./AnswerSolutionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports